<template>
  <div>
    <FormulateInput
        v-model="element.fileDoRename"
        type="checkbox"
        label="Hernoem het bestand"
        help="Vink dit veld aan als u het bestand wilt hernoemen nadat het geupload is."
    />

    <FormulateInput
        v-if="element.fileDoRename"
        v-model="element.fileNewName"
        label="Bestandsnaam"
        type="text"
        validation="required"
        help="Dit veld ondersteund tokens. Vul een bestandsnaam in zonder bestandsextentie."/>

    <eform-tokens
        v-if="element.fileDoRename"
        :tokens="this.getTokensFromSchemaFilterInclude(form.schema, ['text', 'textarea', 'number', 'email', 'date', 'time', 'datetime', 'checkbox_single', 'radio', 'select'])" />
  </div>
</template>

<script>
import EformTokens from "@/components/EformTokens.vue";
import eformHelpers from "@/mixins/eformHelpers";

export default {
  name: 'EformElementEditFile',
  components: {EformTokens},
  mixins: [
    eformHelpers,
  ],
  props: {
    element: Object,
    form: Object,
  },
}
</script>

<style lang="scss" scoped>

</style>
